// CSS Modules - component class name prefix: ShopFooter__

<template>
  <footer :class="$style.container">
    <div :class="[$style.badges, 'columns is-mobile is-multiline']">
      <div class="column is-half-mobile is-one-fifth-tablet">
        <img
          class="ftrlFooter_imageShipping"
          src="https://shop.wika.de/templates/pics/pi_shop_footer_versand.png"
        />
        <p>
          <strong>Kostenfreier Versand</strong>
          Ab 100 Euro Warenwert
        </p>
      </div>
      <div class="column is-half-mobile is-one-fifth-tablet">
        <img
          class="ftrlFooter_imagePayment"
          src="https://shop.wika.de/templates/pics/pi_shop_footer_bezahlen.png"
        />
        <p>
          <strong>Einfache Bezahlung</strong>
          Alle gängigen Zahlungsmittel
        </p>
      </div>
      <div class="column is-one-third-mobile is-one-fifth-tablet">
        <img
          class="ftrlFooter_imageOriginal"
          src="https://shop.wika.de/templates/pics/pi_shop_footer_original.png"
        />
        <p>
          <strong>100% Original</strong>
          Direkt vom Hersteller
        </p>
      </div>
      <div class="column is-one-third-mobile is-one-fifth-tablet">
        <img
          class="ftrlFooter_imageDelivery"
          src="https://shop.wika.de/templates/pics/pi_shop_footer_lieferung.png"
        />
        <p>
          <strong>Schnelle Lieferung</strong>
          1.000.000 Lagergeräte
        </p>
      </div>
      <div class="column is-one-third-mobile is-one-fifth-tablet">
        <img
          class="ftrlFooter_imageSsl"
          src="https://shop.wika.de/templates/pics/pi_shop_footer_ssl.png"
        />
        <p>
          <strong>Sicheres Einkaufen</strong>
          SSL-/TLS-Verschlüsselung
        </p>
      </div>
    </div>
    <div
      :class="[$style.main, 'columns', 'is-multiline', 'is-variable', 'is-5']"
    >
      <div
        :class="[
          $style.links,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <ul>
          <li v-for="(link, index) in footerLinks" :key="index">
            <a :href="link.url" :target="link.newWindow ? '_blank' : '_self'">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
      <div
        :class="[
          $style.text,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <strong :class="$style.title">Kontakt</strong>
        <p>WIKA Alexander Wiegand SE &amp; Co. KG</p>
        <p>Alexander-Wiegand-Str. 30 <br />63911 Klingenberg - Deutschland</p>
        <p>Tel.: +49 9372 132-0</p>
        <p>E-Mail: <a href="mailto:info@wika.de">info@wika.de</a></p>
      </div>
      <div
        :class="[
          $style.text,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <strong :class="$style.title">Fragen?</strong>
        <p>Kontaktieren Sie uns gerne kostenfrei über folgende Nummer:</p>
        <p>
          <strong :class="$style.phone">0800 1810390</strong><br />
          Mo. - Do. 08:00 - 16:30 Uhr<br />
          Fr. 08:00 - 15:00 Uhr
        </p>
      </div>
      <div
        :class="[
          $style.text,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <div class="columns is-multiline is-mobile">
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_Mastercard_de_de_78284.png"
              alt="Master Card"
            />
          </div>
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_Visa_de_de_78288.png"
              alt="Visa"
            />
          </div>
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_Maestro_de_de_94874.png"
              alt="Maestro"
            />
          </div>
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_Paypal_de_de_78285.png"
              alt="PayPal"
            />
          </div>
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_Rechnung_de_de_80372_80372.png"
              alt="Rechnung"
            />
          </div>
          <div class="column is-one-third">
            <img
              src="https://shop.wika.de/upload/PIC_LO_TrustedShops_de_de_78286.png"
              alt="TrustedShops"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      :class="[
        $style.nav,
        'columns',
        'is-vcentered',
        'is-multiline',
        'is-variable',
        'is-5'
      ]"
    >
      <div :class="[$style.copyright, 'column']">
        <div>© 2019 WIKA Alexander Wiegand SE &amp; Co. KG</div>
        <div>
          Kein Verkauf an Privatkunden i.S.d. § 13 BGB - Liefergebiet:
          Deutschland, Österreich.
        </div>
      </div>
      <SocialLinks :socialLinks="socialLinks" />
    </div>
  </footer>
</template>

<script>
import SocialLinks from "../SocialLinks/SocialLinks.vue";

export default {
  name: "ShopFooter",
  components: {
    SocialLinks
  },
  data() {
    return {
      footerLinks: [
        {
          title: "Impressum",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Unternehmen",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Datenschutzhinweise",
          url: "#",
          newWindow: "false"
        },
        {
          title: "AGB",
          url: "#",
          newWindow: "true"
        },
        {
          title: "Kontakt",
          url: "#",
          newWindow: "false"
        }
      ],
      socialLinks: [
        {
          url: "http://blog.wika.de/",
          newWindow: "true",
          icon: "fas fa-comment-alt",
          color: "#3480cf"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-youtube",
          color: "#e62117"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-linkedin-in",
          color: "#0072b1"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-xing",
          color: "#007e7e"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-facebook-f",
          color: "#3c5598"
        }
      ]
    };
  }
};
</script>

<style module lang="scss">
@import "./ShopFooter.scss";
</style>
